/**
 * Phase 18.16-B Batch 3 — /contact PageBanner wrapper.
 *
 * Lives as `topSection` of the /contact CmsPageRenderer route. The
 * legacy "hero" block on the same slug is hidden via
 * `hideBlockTypes={["hero"]}` in App.js and marked "Vervangen" in the
 * Backoffice.
 *
 * The CmsPageRenderer continues to render ContactFormSection as
 * `extraSections` so the contact + quote forms keep working, the
 * /contact?get-quote=1#quote-form anchor still scrolls to the
 * quote form, and the company contact settings (phone, email,
 * finance e-mail, address) keep flowing through ConfigContext.
 */
import React from "react";
import { Headphones } from "lucide-react";
import useInfoPageCms from "../hooks/useInfoPageCms";
import { ToolPageBanner } from "./ToolPageCms";

const FALLBACK = {
  page_banner: {
    eyebrow: "Contact",
    title: "Praat met",
    highlight: "5999Cargo",
    subtitle:
      "WhatsApp, telefoon of e-mail — wij reageren binnen 1 werkdag. Liever direct een prijs? Vraag onderaan deze pagina een offerte aan.",
    badges: [
      { icon: "support", label: "Antwoord binnen 1 werkdag" },
      { icon: "shield",  label: "Vaste prijs op aanvraag" },
      { icon: "package", label: "Heel NL + Caribbean" },
    ],
    cta_primary_label: "Vraag offerte aan",
    cta_primary_url: "/contact?get-quote=1#quote-form",
    cta_secondary_label: "Bel ons",
    cta_secondary_url: "tel:+31488235999",
  },
  intro: {},
  cta_band: {},
};

export default function ContactPageBanner() {
  const { data } = useInfoPageCms("contact", FALLBACK);
  return (
    <ToolPageBanner
      banner={data?.page_banner || FALLBACK.page_banner}
      image="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920"
      imageAlt="5999Cargo klantenservice — vraag offerte aan of stel een vraag"
      eyebrowIcon={Headphones}
      testid="contact-banner"
    />
  );
}
